import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { flushEditor } from "../lib/editorFlush";

interface NavigateToUpgradeOptions {
  reason?: string;
  customMessage?: string;
  successUrl?: string;
  hash?: string;
}

export function useUpgradePage() {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToUpgrade = useCallback(
    async (options?: NavigateToUpgradeOptions) => {
      // If we're leaving the editor, persist the draft and stamp its id into
      // the URL first (no-op outside the editor).
      await flushEditor();

      // Capture the FULL current URL (path + ?search, incl. draftId) as the
      // return target, so the upgrade page's Back button returns to the exact
      // draft rather than a blank /create-post.
      const from =
        typeof window !== "undefined"
          ? window.location.pathname + window.location.search
          : location.pathname;

      const params = new URLSearchParams({ backTo: from });
      if (options?.reason) params.set("reason", options.reason);
      if (options?.customMessage) params.set("message", options.customMessage);
      if (options?.successUrl) params.set("successUrl", options.successUrl);

      const search = params.toString();
      const hash = options?.hash?.replace(/^#/, "");

      navigate(
        `/upgrade${search ? `?${search}` : ""}${hash ? `#${hash}` : ""}`,
        {
          state: { from },
        },
      );
    },
    [location.pathname, navigate],
  );

  return { navigateToUpgrade };
}
